/**
 * Initialize Swiper Gallery
 */
document.addEventListener("DOMContentLoaded", () => {
  const sliderEl = document.querySelector(".gallery-slider");

  if (sliderEl) {
    const slideCount = sliderEl.querySelectorAll(".swiper-slide").length;
    const shouldLoop = slideCount > 3;
    const isMobile = window.innerWidth <= 768;

    new Swiper(".gallery-slider", {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: shouldLoop,
      grabCursor: true,
      centeredSlides: !shouldLoop,
      observer: true,
      observeParents: true,

      // Completely disable zoom on mobile to prevent event hijacking
      zoom: isMobile
        ? false
        : {
            maxRatio: 3,
            minRatio: 1,
            toggle: true,
          },

      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        dynamicBullets: true,
      },

      breakpoints: {
        640: {
          slidesPerView: slideCount < 2 ? 1 : 2,
          spaceBetween: 10,
        },
        992: {
          slidesPerView: slideCount < 3 ? slideCount : 3,
          spaceBetween: 20,
        },
      },
    });
  }

  const testimonialsElement = document.querySelector(".testimonials-slider");

  if (testimonialsElement) {
    const testimonialSwiper = new Swiper(".testimonials-slider", {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      grabCursor: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        // Tablet (ekran >= 768px)
        768: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        // Desktop (ekran >= 1024px)
        1024: {
          slidesPerView: 3,
          spaceBetween: 40,
          centeredSlides: false,
        },
      },
    });
  }
});
